import { atom } from 'recoil';
import { Image3D } from '~/domain/patient/image3d';
import { RigidRegistration } from '~/domain/patient/rigidRegistration';

export const primaryImageState = atom<Image3D | undefined>({
    key: 'primaryImageState',
    default: undefined,
    dangerouslyAllowMutability: true,
});

export const blendImageState = atom<Image3D | undefined>({
    key: 'blendImageState',
    default: undefined,
    dangerouslyAllowMutability: true,
});

export const selectedRegistrationState = atom<RigidRegistration | undefined>({
    key: 'selectedRegistrationState',
    default: undefined,
    dangerouslyAllowMutability: true,
});

export const imageBlendAmountState = atom<number>({
    key: 'imageBlendAmountState',
    default: 50,
});
